"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var CompetitorConverter_1 = require("./conversions/CompetitorConverter");

var CompetitorConverterImpl_1 = require("./conversions/CompetitorConverterImpl");

var CompetitorSiteConverter_1 = require("./conversions/CompetitorSiteConverter");

var CompetitorSiteConverterImpl_1 = require("./conversions/CompetitorSiteConverterImpl");

var CompetitorsPriorityConverter_1 = require("./conversions/CompetitorsPriorityConverter");

var CompetitorsPriorityConverterImpl_1 = require("./conversions/CompetitorsPriorityConverterImpl");

var GroupOfSitesConverter_1 = require("./conversions/GroupOfSitesConverter");

var GroupOfSitesConverterImpl_1 = require("./conversions/GroupOfSitesConverterImpl");

var GroupOfSitesIntersectionConverter_1 = require("./conversions/GroupOfSitesIntersectionConverter");

var GroupOfSitesIntersectionConverterImpl_1 = require("./conversions/GroupOfSitesIntersectionConverterImpl");

var InternalSiteConverter_1 = require("./conversions/InternalSiteConverter");

var InternalSiteConverterImpl_1 = require("./conversions/InternalSiteConverterImpl");

var SiteFormatChangeConverter_1 = require("./conversions/SiteFormatChangeConverter");

var SiteFormatChangeConverterImpl_1 = require("./conversions/SiteFormatChangeConverterImpl");

var SiteNewToSimilarConverter_1 = require("./conversions/SiteNewToSimilarConverter");

var SiteNewToSimilarConverterImpl_1 = require("./conversions/SiteNewToSimilarConverterImpl");

var StockConverter_1 = require("./conversions/StockConverter");

var StockConverterImpl_1 = require("./conversions/StockConverterImpl");
/**
 * Configures site app module.
 */


var SiteAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(SiteAppModule, _AppModule_1$AppModul);

  function SiteAppModule() {
    var _this;

    _classCallCheck(this, SiteAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'siteAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SiteAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(CompetitorsPriorityConverter_1.CompetitorsPriorityConverter).to(CompetitorsPriorityConverterImpl_1.CompetitorsPriorityConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(CompetitorSiteConverter_1.CompetitorSiteConverter).to(CompetitorSiteConverterImpl_1.CompetitorSiteConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(GroupOfSitesConverter_1.GroupOfSitesConverter).to(GroupOfSitesConverterImpl_1.GroupOfSitesConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(GroupOfSitesIntersectionConverter_1.GroupOfSitesIntersectionConverter).to(GroupOfSitesIntersectionConverterImpl_1.GroupOfSitesIntersectionConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(CompetitorConverter_1.CompetitorConverter).to(CompetitorConverterImpl_1.CompetitorConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(InternalSiteConverter_1.InternalSiteConverter).to(InternalSiteConverterImpl_1.InternalSiteConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SiteNewToSimilarConverter_1.SiteNewToSimilarConverter).to(SiteNewToSimilarConverterImpl_1.SiteNewToSimilarConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(StockConverter_1.StockConverter).to(StockConverterImpl_1.StockConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SiteFormatChangeConverter_1.SiteFormatChangeConverter).to(SiteFormatChangeConverterImpl_1.SiteFormatChangeConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return SiteAppModule;
}(AppModule_1.AppModule);

exports.SiteAppModule = SiteAppModule;